/**
 * Groupe de boutons-filtres contrôlé, présentationnel. Options (et compteurs)
 * fournis par l'appelant ; le filtrage reste chez l'appelant.
 *
 * @param {Array<{key,label,icon?,count?,activeColor?}>} options
 * @param {string} value                 clé active
 * @param {(key:string)=>void} onChange
 * @param {'segments'|'pills'} [variant]  'segments' = boutons collés (onglets) ; 'pills' = arrondis espacés
 * @param {string} [className]
 */
const FiltrePills = ({ options = [], value, onChange, variant = 'segments', className = '' }) => {
  if (variant === 'pills') {
    return (
      <div className={`flex flex-wrap gap-2 ${className}`}>
        {options.map((o) => {
          const actif = value === o.key;
          return (
            <button
              key={o.key}
              type="button"
              onClick={() => onChange(o.key)}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium transition-all whitespace-nowrap ${
                actif ? `${o.activeColor || 'bg-blue-600'} text-white shadow` : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
              }`}
            >
              {o.icon ? <span>{o.icon}</span> : null}
              <span>{o.label}</span>
              {o.count !== undefined ? <span className={actif ? 'opacity-90' : 'opacity-60'}>({o.count})</span> : null}
            </button>
          );
        })}
      </div>
    );
  }
  // segments : boutons collés dans un cadre arrondi
  return (
    <div className={`flex rounded-xl overflow-hidden border border-gray-200 ${className}`}>
      {options.map((o) => {
        const actif = value === o.key;
        return (
          <button
            key={o.key}
            type="button"
            onClick={() => onChange(o.key)}
            className={`px-4 py-2.5 text-sm font-medium transition-colors inline-flex items-center gap-1.5 whitespace-nowrap ${
              actif ? `${o.activeColor || 'bg-blue-600'} text-white` : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
          >
            {o.icon ? <span>{o.icon}</span> : null}
            <span>
              {o.label}
              {o.count !== undefined ? ` (${o.count})` : ''}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default FiltrePills;
